import { List } from 'immutable';

import config from '../config';
import ConfigAPIClient, { NotFoundError } from '../lib/ConfigAPIClient';
import APIClient from '../lib/APIClient';
import { resolve, resolveAll } from '../helpers/LinkMapper';
import Banner from '../records/Banner';
import JourneyNotification from '../records/JourneyNotification';
import Reason from '../records/customer/keygo/completeJourney/Reason';

const configServiceBrand = () => config.get('configServiceBrand') || config.get('brand');
const base = () => `/confsvc/brands/${configServiceBrand()}/environments/${config.get('environment')}`;

const ConfigService = {

    async loadBannerConfig () {
        const endpoint = `${base()}/banners`;
        const response = await ConfigAPIClient.get(endpoint);
        return resolve(response.result).as(Banner);
    },

    async loadJourneyNotifications (data = {}) {
        const endpoint = `${base()}/journey-notifications/search`;
        const response = await ConfigAPIClient.post(endpoint, data);
        if (response.result) {
            return resolveAll(response.result).as(JourneyNotification);
        } else {
            return new List();
        }
    },

    async checkTocOnlyRoute (search) {
        try {
            const endpoint = '/config/tocs/route/availability';
            const originNlc = search.origin.nlc;
            const destinationNlc = search.destination.nlc;
            const response = await APIClient.get(endpoint, { originNlc, destinationNlc });
            return response.result.isAvailable;
        } catch (e) {
            if (e instanceof NotFoundError) {
                return null;
            }
            throw e;
        }
    },

    async getKeyGoAmendmentReasons () {
        const endpoint = `${base()}/reasons`;
        const response = await ConfigAPIClient.get(endpoint);
        if (response.result) {
            return resolveAll(response.result).as(Reason);
        } else {
            return new List();
        }
    }
};

export default ConfigService;



// WEBPACK FOOTER //
// ./src/services/ConfigService.js